
import HeartCrack from '../../../assets/svg/HeartCrack';
import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

const StatusErrorPage = () => {
    const translate = useTranslation();
    return (
        <StatusPage
            icon={<HeartCrack />}
            title={translate(`page.status-error.title`)}
            body={translate(`page.status-error.description`)}
        />
    );
};

export default StatusErrorPage;
